/* EN Verkooppunten v1.0: laadt Stockist pas als de zoeker in beeld komt */
(function () {
  var SRC = 'https://stockist.co/embed/v1/widget.min.js';

  function load(force) {
    if (!document.querySelector('[data-en-sl]')) return;
    var old = document.getElementById('en-sl-script');
    if (old && !force) return;
    if (old) old.parentNode.removeChild(old);
    var s = document.createElement('script');
    s.id = 'en-sl-script';
    s.async = true;
    s.src = force ? SRC + '?t=' + Date.now() : SRC;
    document.head.appendChild(s);
  }

  function init() {
    var el = document.querySelector('[data-en-sl]');
    if (!el) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(false); }
      }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else {
      load(false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-en-sl]')) load(true);
  });
})();
